'use client';

import React from 'react';
import Topbar from '@/components/Topbar';
import Footer from '@/components/Footer';
import { FileText } from 'lucide-react';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[hsl(222,47%,6%)]">
      <Topbar />
      <main className="pt-16">
        <div className="max-w-3xl mx-auto px-4 lg:px-8 py-12">
          <div className="flex items-center gap-3 mb-8">
            <FileText className="w-6 h-6 text-amber-400" />
            <div>
              <h1 className="text-2xl font-bold text-white">Terms of Service</h1>
              <p className="text-slate-500 text-sm">Last updated: 1 April 2026</p>
            </div>
          </div>

          <div className="space-y-6">
            {[
              {
                title: "1. Acceptance of Terms",
                content: "By accessing or using DrivenMarket, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree, please do not use the platform. These terms constitute a legally binding agreement between you and DrivenMarket Ltd."
              },
              {
                title: "2. The Platform",
                content: "DrivenMarket is an online marketplace connecting buyers and sellers of working dog, sport dog, and professional training equipment in the UK. We are not a party to transactions between buyers and sellers. We provide the platform and payment infrastructure but do not own, inspect, or guarantee any items listed."
              },
              {
                title: "3. User Accounts",
                content: "You must be 18 or older to create an account. You are responsible for maintaining the security of your account credentials. You must provide accurate information when registering. We reserve the right to suspend or terminate accounts that violate these terms."
              },
              {
                title: "4. Listing Rules",
                content: "Sellers must accurately describe items and disclose any defects. Prohibited listings include: stolen goods, counterfeit items, illegal weapons, items that violate animal welfare laws, and any item prohibited under UK law. Puppy and dog listings must comply with Lucy's Law and all applicable breeding regulations. We reserve the right to remove any listing at our discretion."
              },
              {
                title: "5. Payments & Fees",
                content: "Payments are processed securely via Stripe. Funds are held in escrow until the buyer confirms receipt or the auto-release period expires. DrivenMarket charges a platform fee on completed sales. Fees are displayed at the time of listing. Payouts are processed to verified Stripe Connect accounts."
              },
              {
                title: "6. Buyer Protection",
                content: "Buyers may raise a dispute within 7 days of the auto-release date if an item is not as described or not received. Disputes are reviewed by our team. We reserve the right to issue refunds or release funds based on evidence provided. Our buyer protection does not cover change-of-mind purchases."
              },
              {
                title: "7. Prohibited Conduct",
                content: "You must not: attempt to circumvent platform fees by transacting off-platform, harass or threaten other users, post false or misleading information, use automated tools to scrape or manipulate the platform, or engage in any fraudulent activity. Violations may result in immediate account termination and referral to law enforcement."
              },
              {
                title: "8. Intellectual Property",
                content: "Content you post on DrivenMarket (photos, descriptions) remains yours. By posting, you grant us a non-exclusive licence to display and promote your listings on the platform. The DrivenMarket brand, logo, and platform code are our intellectual property."
              },
              {
                title: "9. Limitation of Liability",
                content: "To the maximum extent permitted by UK law, DrivenMarket is not liable for: the quality or legality of items listed, disputes between buyers and sellers, loss of data, or indirect or consequential losses. Our total liability to you shall not exceed the fees paid by you in the 12 months preceding the claim."
              },
              {
                title: "10. Governing Law",
                content: "These terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales."
              },
              {
                title: "11. Changes to Terms",
                content: "We may update these terms from time to time. We will notify you of material changes by email or prominent notice on the platform. Continued use after changes constitutes acceptance."
              },
              {
                title: "12. Contact",
                content: "DrivenMarket Ltd, England & Wales. Email: legal@drivenmarket.co.uk"
              }
            ]?.map((section) => (
              <div key={section?.title} className="bg-[hsl(222,40%,9%)] border border-[hsl(222,25%,18%)] rounded-xl p-6">
                <h2 className="text-base font-semibold text-white mb-3">{section?.title}</h2>
                <p className="text-slate-400 text-sm leading-relaxed">{section?.content}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
